import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from "@/lib/utils";
interface MobileMenuProps {
  isOpen: boolean;
  onNavigate: (sectionId: string) => void;
}
const MobileMenu = ({
  isOpen,
  onNavigate
}: MobileMenuProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleSectionNavigation = (sectionId: string) => {
    if (window.location.pathname !== '/') {
      // Navigate to home first, then scroll to section
      navigate('/');
      setTimeout(() => {
        onNavigate(sectionId);
      }, 100);
    } else {
      // Already on home page, just scroll
      onNavigate(sectionId);
    }
  };
  return <div className={cn("md:hidden fixed top-16 left-0 right-0 bg-white/95 backdrop-blur-md shadow-lg transition-all duration-300 overflow-hidden z-50", isOpen ? "max-h-screen py-4" : "max-h-0 py-0")}>
      <div className="container mx-auto px-6 flex flex-col space-y-4">
        <Link to="/" className="py-2 text-gray-700 hover:text-kbeauty-brown transition-colors">
          {t('nav.home')}
        </Link>
        <Link to="/products" className="py-2 text-gray-700 hover:text-kbeauty-brown transition-colors">
          {t('nav.products')}
        </Link>
        <Link to="/behind-bottle" className="py-2 text-gray-700 hover:text-kbeauty-brown transition-colors">
          {t('nav.brandHistory')}
        </Link>
        <button className="text-left py-2 text-gray-700 hover:text-kbeauty-brown transition-colors" onClick={() => handleSectionNavigation('why-it-works')}>
          {t('nav.whyItWorks')}
        </button>
        <Link to="/reviews" className="py-2 text-gray-700 hover:text-kbeauty-brown transition-colors">
          {t('nav.reviews')}
        </Link>
        <Link to="/faq" className="py-2 text-gray-700 hover:text-kbeauty-brown transition-colors">
          {t('nav.faq')}
        </Link>
        
      </div>
    </div>;
};
export default MobileMenu;